<template>
    <div class="userCenter banxin">
      <div class="leftMenu">
        <div class="leftMenuBox">
          <el-menu :default-active="defaultActive" router>
            <div class="menu-section">
                <p class="section-title">Personal Center</p>
                <el-menu-item class="menu-item" index="userInfo">
                  <i class="el-icon-user"></i>
                  <span class="title">Basic Information</span>
                </el-menu-item>
                <el-menu-item class="menu-item" index="address">
                  <i class="el-icon-location-outline"></i>
                  <span class="title">Address Management</span>
                </el-menu-item>
            </div>
            <div class="menu-section">
                <p class="section-title">Trade Management</p>
                <el-menu-item class="menu-item" index="myOrder">
                  <i class="el-icon-tickets"></i>
                  <span class="title">My Orders</span>
                </el-menu-item>
                <el-menu-item class="menu-item" index="myEvaluate">
                  <i class="el-icon-chat-dot-round"></i>
                  <span class="title">My Reviews</span>
                </el-menu-item>
                <el-menu-item class="menu-item" index="favorites">
                  <i class="el-icon-star-off"></i>
                  <span class="title">My Favorites</span>
                </el-menu-item>
            </div>
          </el-menu>
        </div>
      </div>
      <div class="userCenterInfo flex1">
        <router-view></router-view>
      </div>
    </div>
</template>
<script>
export default {
    name: 'userCenter',
    data () {
        return {}
    },
    computed: {
        defaultActive: function () {
        return this.$route.path.replace('/', '')
        }
    },
    // 修改背景色
    beforeCreate () {
        document.querySelector('body').setAttribute('style', 'background-color:#F6F6F8')
    },
    beforeDestroy () {
        document.querySelector('body').removeAttribute('style')
    }
}
</script>
<style lang="scss" scoped>
.userCenter {
    display: flex;
    max-width: $container-width;
    margin: 40px auto 100px;
    gap: 32px;

    .leftMenu {
        width: 260px;
        flex-shrink: 0;

        .leftMenuBox {
            background: $white;
            border-radius: 20px;
            padding: 24px 16px;
            box-shadow: $shadow-sm;
            border: 1px solid $gray-100;
        }

        .el-menu {
            border: 0;
            background: transparent;

            .menu-section {
                margin-bottom: 32px;
                &:last-child { margin-bottom: 0; }
                
                .section-title {
                    font-size: 13px;
                    font-weight: 700;
                    color: $gray-400;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    padding-left: 16px;
                    margin-bottom: 12px;
                }
            }

            .menu-item {
                height: 50px;
                line-height: 50px;
                margin-bottom: 4px;
                border-radius: 12px;
                font-size: 15px;
                color: $gray-600 !important;
                display: flex;
                align-items: center;
                padding-left: 16px !important;
                transition: $transition-base;

                i {
                    margin-right: 12px;
                    font-size: 18px;
                    color: $gray-400;
                    transition: inherit;
                }

                &:hover {
                    background-color: $gray-50;
                    color: $primary-color !important;
                    
                    i { color: $primary-color; }
                }

                &.is-active {
                    background-color: rgba($primary-color, 0.08);
                    color: $primary-color !important;
                    font-weight: 700;

                    i { color: $primary-color; }
                }
            }
        }
    }
    
    .userCenterInfo {
        min-width: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/index.vue